import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// P1-I1: загружаем ВСЕ namespace из ./locales/{lang}/*.json через webpack require.context
// (CRA 5.0.1 / react-scripts 5 поддерживает эту фичу). Раньше здесь были руками
// прописаны ~44 импорта, но в локалях ~89 файлов — половина namespace вообще не
// попадала в ресурсы i18next, и t('namespace.key') возвращало голый ключ.
//
// Использование осталось прежним:
//   const { t } = useTranslation('auth')        // -> ru/auth.json
//   t('login_form.title')
// или по-старому через объединённый common namespace:
//   const { t } = useTranslation('common')
//   t('auth.login_form.title')
//
// Имя namespace = имя файла без расширения (acaademForm.json -> 'acaademForm').

const SUPPORTED_LANGS = ['ru', 'en', 'ky']

function loadResources() {
  const resources = {}
  // Webpack require.context: один статический вызов на каждый язык — иначе
  // webpack не сможет вычислить контекст во время сборки. Поэтому НЕ выносим
  // путь в переменную внутри одного require.context — пишем литералы.
  const contexts = {
    ru: require.context('./locales/ru', false, /\.json$/),
    en: require.context('./locales/en', false, /\.json$/),
    ky: require.context('./locales/ky', false, /\.json$/),
  }
  for (const lang of SUPPORTED_LANGS) {
    const ctx = contexts[lang]
    if (!ctx) continue
    const bag = {}
    ctx.keys().forEach((key) => {
      // key выглядит как './auth.json'
      const ns = key.replace(/^\.\//, '').replace(/\.json$/, '')
      bag[ns] = ctx(key)
    })
    resources[lang] = bag
  }
  return resources
}

const LANGS = loadResources()

// Список namespace берём из ru — он считается «эталонным»; en/ky могут отставать,
// но i18next отработает fallback на ru.
const NS_LIST = Object.keys(LANGS.ru || {})

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: LANGS,
    supportedLngs: SUPPORTED_LANGS,
    nonExplicitSupportedLngs: true,
    fallbackLng: 'ru',
    defaultNS: 'common',
    ns: NS_LIST,
    cleanCode: true,
    // debug отключён — иначе i18next спамит в консоль missingKey предупреждениями.
    // Если нужно временно включить для отладки: REACT_APP_I18N_DEBUG=1.
    debug: process.env.REACT_APP_I18N_DEBUG === '1',
    saveMissing: false,
    returnEmptyString: false,
    react: { useSuspense: false },
    // Тихий handler — даже если debug=true, не логировать в консоль.
    parseMissingKeyHandler: (key, defaultValue) => defaultValue || key,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'lang',
      caches: ['localStorage'],
    },
  })

export default i18n
